
export const ACCESS_TOKEN = 'Authorization'
export const USER = 'USER'
export const MENUS = 'MENUS'
export const MENU_BUTTONS = 'MENU_BUTTONS'
export const SIDEBAR_TYPE = 'SIDEBAR_TYPE'

export const DEFAULT_MULTI_TAB = 'DEFAULT_MULTI_TAB'

export const TABS_ROUTES = 'Tabs-Routes' // 标签页

export const PROJECT_EDIT = 'Project_IsEdit' 


